import { render, staticRenderFns } from "./SoftNum.vue?vue&type=template&id=005274db&scoped=true"
import script from "./SoftNum.vue?vue&type=script&lang=js"
export * from "./SoftNum.vue?vue&type=script&lang=js"
import style0 from "./SoftNum.vue?vue&type=style&index=0&id=005274db&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005274db",
  null
  
)

export default component.exports